import Layout from '@/layout'
const jxsRouter = {
  path: '/jxs',
  component: Layout,
  name: 'jxs',
  meta: {
    title: '代理商管理',
    icon: 'el-icon-s-home',
    roles: ['root', 'business']
  },
  children: [

    {
      path: 'company_create',
      name: 'jxsCompanyCreate',
      component: () => import('@/views/jxs/company/companyCreate'),
      meta: { title: '代理商创建', icon: 'el-icon-plus', noCache: false }
    },
    {
      path: 'company_edit',
      name: 'jxsCompanyEdit',
      component: () => import('@/views/jxs/company/companyUpdate'),
      meta: { title: '代理商公司更新', icon: 'el-icon-refrigerator', noCache: false },
      hidden: true
    },
    {
      path: 'company_table',
      name: 'jxsCompanyTable',
      component: () => import('@/views/jxs/company/companyTable'),
      meta: { title: '代理商公司列表', icon: 'el-icon-s-unfold', noCache: false }
    }
  ]
}
export default jxsRouter
